import { render, staticRenderFns } from "./VolunteerMatchCustomerDetails.vue?vue&type=template&id=64d1f138"
import script from "./VolunteerMatchCustomerDetails.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchCustomerDetails.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchCustomerDetails.vue?vue&type=style&index=0&id=64d1f138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports